/**
 * SearchForm.js — Home page search form with filter support.
 *
 * Renders a keyword search input with autocomplete drawn from all known
 * program types, practice areas, CPD categories, topics, and delivery modes.
 * On submit (or Enter), navigates to /search with the selected filters
 * encoded as query parameters.
 *
 * Also renders clickable popular tag chips passed in via props.PopularTag.
 *
 * Props:
 *  - PopularTag {Array}   List of popular tag strings from the admin panel.
 *  - GAurl {string}       Google Ads click-ID query string.
 */

// ─── External libraries ───────────────────────────────────────────────────────
import React, { useState } from 'react';
import {
    Container,
    Form,
    Button,
} from 'react-bootstrap';
import {
    SearchIconNew,
} from "../../icons";
import { Hint } from 'react-autocomplete-hint';

// ─── Constants ────────────────────────────────────────────────────────────────

/** All known program type labels — used to classify a popular tag click. */
const ProgramType = [
    "Live Streamed One Hour Seminars",
    "Live Streamed Conferences and Intensives",
    "Live Streamed Practical Workshops",
    "Onsite Programs",
    "Pre-Recorded Webcasts",
];

/** Known practice area labels. */
const PracticeArea = [
    "Advocacy", "Building & Construction", "Business & Contracts", "Consumer",
    "Corporate & In-House Counsel", "Costs", "Criminal", "Employment & Workplace Relations",
    "Ethics", "Family", "Finance, Tax, Superannuation", "Government, Privacy & FOI",
    "Health & Aged Care", "Insolvency & Restructuring", "Intellectual Property",
    "Litigation & Dispute Resolution", "Migration", "Personal Injury & Medico-Legal",
    "Planning & Environment", "Professional Skills & Practice Management",
    "Property & Leases", "Sports Law", "Trusts & Succession Planning", "Wills & Estates",
];

/** Format type labels (non-live content). */
const formatType = ["Pre-Recorded Webcasts", "Books"];

/** CPD topic labels. */
const Topics = [
    "Administrative Law", "Civil Litigation", "Commercial and Corporate Practice",
    "Employment and Industrial Relations", "Ethics and Professional Responsibility",
    "Lawyer’s Skills including Advocacy", "Problem Solving", "Property Law",
    "Risk Management", "Trust and Office Accounting",
    "Work Management Business Skills (including Risk Management)",
];

/** CPD category labels. */
const CPDCategories = [
    "Ethics & Professional Responsibility", "Professional Skills",
    "Practice Management & Business Skills", "Substantive Law",
];

/** Delivery mode labels. */
const DeliverMode = ["Face to Face", "Live Stream"];

// ─── Helper functions ─────────────────────────────────────────────────────────

/**
 * Recursively flattens a nested array.
 *
 * @param {Array} arr
 * @returns {Array}
 */
const flatten = (arr) => {
    return arr.reduce(function (flat, toFlatten) {
        return flat.concat(Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten);
    }, []);
};

// ─── Main component ───────────────────────────────────────────────────────────

/**
 * SearchForm — keyword search form with filter tag support.
 * See file-level JSDoc for full props description.
 */
export const SearchForm = (props) => {
    const [SearchText, setSearchText] = useState("");


    const GenerateSearchURL = () => {
        if ( SearchText !== "" ) {
            var MakeURL = "?";            

            if (SearchText !== "") {
                MakeURL += "&keyword=" + SearchText;
            }
            return MakeURL

        }
    }

    /***
     * Auto complete list
     */

    const AutoComplteList = () => {
        var ArraysTemp = [
            [ProgramType],
            [formatType],
            [PracticeArea],
            [Topics],
            [CPDCategories],
            [DeliverMode]
        ];

        var ReturnArray = [];
        flatten(ArraysTemp).forEach((val) => {
            ReturnArray.push(val);
        });
        return ReturnArray;
    }



    /****
  *
  */
    const AutoCompltehandleOnSelect = (item) => {
        let TagValue = item;        
        setSearchText(TagValue);
    }




    /***
        * Detect enter key
        */
    const HitEnter = (event) => {
        event.preventDefault();
        window.location.href = window.location.origin + '/search' + GenerateSearchURL();
    }

    return (
        <div className='search_wrapper' id="search_wrapper">
            <Container>

                <div className='search_inner'>
                    <Form onSubmit={HitEnter}>
                        <div className='filter_search_block'>
                            <div className='sc-eCYdqJ'>
                                <div className="wrapper">
                                    <div className="sc-hKMtZM jVgFww d-none d-md-block">
                                        <Hint options={AutoComplteList()} allowTabFill={true} className="">
                                            <input
                                                className="search_filed"
                                                placeholder="Search for a program title, program description or presenter name"
                                                value={SearchText}
                                                onChange={e => AutoCompltehandleOnSelect(e.target.value)} />
                                        </Hint>
                                    </div>
                                    <div className="sc-hKMtZM jVgFww d-md-none">
                                        <Hint options={AutoComplteList()} allowTabFill={true} className="d-md-none">
                                            <input
                                                className="search_filed"
                                                placeholder="Search for a program title, program description or presenter name"
                                                value={SearchText}
                                                onChange={e => AutoCompltehandleOnSelect(e.target.value)} />
                                        </Hint>
                                    </div>
                                </div>
                            </div>
                            <div className={`search-btns-reveal${SearchText ? ' search-btns-reveal--active' : ''}`}>
                                <button
                                    type="button"
                                    className="search-clear-btn"
                                    onClick={() => setSearchText("")}
                                    aria-label="Clear search"
                                    tabIndex={SearchText ? 0 : -1}
                                >
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 4L4 12" stroke="#231F20" strokeWidth="1.3" strokeLinecap="round"/>
                                        <path d="M4 4L12 12" stroke="#231F20" strokeWidth="1.3" strokeLinecap="round"/>
                                    </svg>
                                </button>
                                <Button type="submit" className="search-submit-btn" tabIndex={SearchText ? 0 : -1}>Search</Button>
                            </div>
                            <Button type="submit" variant="search"><SearchIconNew /></Button>
                        </div>


                    </Form>
                </div>

            </Container >
        </div >
    )
}

export default SearchForm;
